import gql from "graphql-tag";

const SOCIALS_QUERY = gql`
    query{
        socialAccount{
            instagram
            twitter
            facebook
            shop
            pinterest
        }
    }
`;

export default SOCIALS_QUERY